import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
  authPages,
  routesArray,
  whitePages,
} from "shared/constants/routerConsts";
import Popup from "shared/ui/Popup";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { useAppDispatch } from "shared/redux/hooks";
import { setId, setName } from "shared/redux/reducers/MallSlice";
import { useCookies } from "react-cookie";
import { setAuthKey, setUserInfo } from "shared/redux/reducers/UserSlice";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import qs from "qs";

const Layout: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [cookies, setCookies, removeCookie] = useCookies([
    "auth_key",
    "user_id",
  ]);

  //

  const checkAuthorized = () => {
    const auth_key = cookies.auth_key;

    api
      .post(
        API_ROUTES.ACCOUNT,
        qs.stringify({
          ...defaultOptions(),
          user_id: cookies.user_id,
          auth_key: cookies.auth_key,
        })
      )
      .then((res) => {
        dispatch(setUserInfo(res.data));
        dispatch(setAuthKey(auth_key));
      })
      .catch((e) => {
        if (e.status === 401) {
          removeCookie("auth_key");
          removeCookie("user_id");
        }
      });
  };

  useEffect(() => {
    const mallId = localStorage.getItem("mall_id");
    const mallName = localStorage.getItem("mall_name");

    checkAuthorized();

    if (!mallId || !mallName) {
      navigate(ROUTES_PATH.SELECT_MALL);
    } else {
      dispatch(setName(mallName));
      dispatch(setId(Number(mallId)));
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (authPages.includes(pathname) && (!cookies.auth_key || !cookies.user_id))
      navigate(ROUTES_PATH.REGISTRATION);
  }, [pathname, cookies]);

  return (
    <div className="wrapper">
      <div
        className={`wrapper ${whitePages.includes(pathname) ? "white" : ""}`}
      >
        <Routes>
          {routesArray.map((item) => (
            <Route key={item.path} {...item} />
          ))}
        </Routes>

        <Popup />
      </div>
    </div>
  );
};

export default Layout;
